
import {
  defineComponent,
  PropType,
  watch,
  ref,
  computed,
  onMounted,
} from "vue";
import { PositionDocumentItem } from "@/types";
import InputCourse from "@/components/InputCourse.vue";

interface PositionItemDto {
  item: PositionDocumentItem;
  isSupervisor: boolean;
}

export default defineComponent({
  name: "PositionDocumentPanel",
  components: { InputCourse },
  props: {
    assessmentData: {
      type: String as PropType<string | null>,
      required: true,
    },
    supervisorAssessmentData: {
      type: String as PropType<string | null>,
      required: false,
    },
    isSupervisor: {
      type: Boolean,
      required: true,
    },
    isEmployee: {
      type: Boolean,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    const items = ref<PositionDocumentItem[]>([]);
    const supervisorItems = ref<PositionDocumentItem[]>([]);
    // const mergeItems = computed<PositionItemDto[]>(() => {
    //   const result: PositionItemDto[] = [];
    //   if (props.isEmployee) {
    //     result.push(
    //       ...items.value.map<PositionItemDto>((x) => ({
    //         item: x,
    //         isSupervisor: false,
    //       }))
    //     );
    //   }
    //   if (props.isSupervisor) {
    //     result.push(
    //       ...supervisorItems.value.map<PositionItemDto>((x) => ({
    //         item: x,
    //         isSupervisor: true,
    //       }))
    //     );
    //   }

    //   // result.sort(
    //   //   (x, y) =>
    //   //     (x.item.sort - y.item.sort) * 10 +
    //   //     ((x.isSupervisor ? 1 : 0) - (y.isSupervisor ? 1 : 0))
    //   // );
    //   return result;
    // });

    watch(
      () => props.assessmentData,
      () => (items.value = JSON.parse(props.assessmentData ?? "[]"))
    );
    watch(
      () => props.supervisorAssessmentData,
      () =>
        (supervisorItems.value = JSON.parse(
          props.supervisorAssessmentData ?? "[]"
        ))
    );

    const localIsComplete = computed(() => {
      return (
        supervisorItems.value.filter((x) => !x.answer).length === 0 &&
        supervisorItems.value.filter((x) => !x.courseId).length === 0
      );
    });

    // const onInputValue = () => {

    // };
    watch(
      () => supervisorItems.value,
      () => {
        if (props.isSupervisor === true) {
          emit(
            "update:supervisorAssessmentData",
            JSON.stringify(supervisorItems.value)
          );
          emit("update:isComplete", localIsComplete.value);
        }
      },
      { deep: true }
    );

    const onAddNewCourse = () => {
      supervisorItems.value.push({
        courseId: "",
        courseDescription: "",
        mandatory: false,
        sort: 0,
        answer: null,
      } as PositionDocumentItem);
    };

    const onDeleteItem = (index: number) => {
      supervisorItems.value.splice(index, 1);
    };

    onMounted(() => {
      items.value = JSON.parse(props.assessmentData ?? "[]");
      supervisorItems.value = JSON.parse(
        props.supervisorAssessmentData ?? "[]"
      );
    });

    return {
      items,
      supervisorItems,
      onAddNewCourse,
      onDeleteItem,
      localIsComplete,
      // mergeItems,
      // isRadioReadonly,
    };
  },
});
